// src/views/Guest/NavBar.tsx

import { useRef, useState } from 'react';
import Gleap from 'gleap';
import {
  RiCloseLargeLine,
  RiCustomerService2Line,
  RiMenuLine,
} from '@remixicon/react';
import useOnClickOutside from '@/shared/hooks/useOnClickOutside';
import i18n from '@/shared/i18n/i18n';
import { Button } from '@UI/components/Button/button';
import { cx } from '@/components/UI/lib/utils';
import { useUserSettingsStore } from '@/domains/user/userSettings.store';

const NavBar = () => {
  const isCollapsed = useUserSettingsStore(
    (state) => state.settings.menu_collapsed,
  );
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isButtonAvailable, setIsButtonAvailable] = useState(true);

  const refPanel = useRef(null);

  useOnClickOutside(refPanel, () => {
    if (isActive) {
      setIsButtonAvailable(false);
      setIsActive(false);
      setTimeout(() => setIsButtonAvailable(true), 200);
    }
  });

  const handleHelpClick = () => {
    Gleap.open();
  };

  return (
    <>
      <Button
        onClick={() => {
          if (isButtonAvailable) setIsActive(!isActive);
        }}
        icon={isActive ? RiCloseLargeLine : RiMenuLine}
        variant="ghost"
        className="block lg:hidden w-10 h-10 flex items-center justify-center"
      />

      <div
        ref={refPanel}
        className={cx(
          'mobilePanel py-4 px-8 max-lg:p-4',
          `${isActive ? 'max-lg:block' : 'max-lg:hidden'}`,
        )}
      >
        <div>
          <Button
            icon={RiCustomerService2Line}
            iconPosition="left"
            variant="ghost"
            size="md"
            className={cx(
              'menuButton',
              `${isCollapsed ? 'justify-center collapsed' : 'justify-start'}`,
            )}
            onClick={handleHelpClick}
          >
            {isCollapsed || i18n.t('navBar.help')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default NavBar;
